import { createSelector } from 'reselect';
import cloneDeep from 'lodash/cloneDeep';

import { initialState } from './reducer';

import { getMainClientInfo } from '../Main/selectors';

const selectDisclosuresDomain = (state) => state.disclosures || initialState;

const selectDisclosuresProps = (state, props) => props;

const selectDisasterAssistanceDisclosurePhoneNumber = () => createSelector(
  getMainClientInfo('disasterAssistanceDisclosurePhoneNumber'),
  (disasterAssistanceDisclosurePhoneNumber) => disasterAssistanceDisclosurePhoneNumber,
);

const selectPageView = () => createSelector(
  selectDisclosuresProps,
  (props) => props.match.params.view || '',
);

const makeSelectDisclosures = (prop) => createSelector(
  selectDisclosuresDomain,
  (state) => state[prop],
);

const makeSelectDisclosuresContent = () => createSelector(
  makeSelectDisclosures('disclosures'),
  (disclosures) => {
    const disclosuresCopy = cloneDeep(disclosures);
    return Object.entries(disclosuresCopy)
      .reduce((acc, [key, { content, name }]) => {
        const contentWithNewlines = content.map((block) => {
          const { inlineBlocks } = block;
          // Newline is represented by CMS as a single inline block, with empty text.
          // Lists cannot contain newlines, otherwise each would represent a separate list
          if (inlineBlocks && inlineBlocks.length === 1 && !inlineBlocks[0].text.trim()) {
            inlineBlocks[0].text = '\uFEFF'; // unicode char for zero-width, no-break space
          }
          return block;
        });
        acc[key] = { content: contentWithNewlines, name };
        return acc;
      }, {});
  },
);

export default makeSelectDisclosures;
export {
  makeSelectDisclosuresContent,
  selectDisasterAssistanceDisclosurePhoneNumber,
  selectDisclosuresDomain,
  selectPageView,
};
